export default __webpack_public_path__ + "static/media/MIMATIC-USDC.e5e0f3d5.png";